import * as React from 'react';
import { Card, SelectionStatus, Switch } from '@symphony-ui/uitoolkit-components';
import StreamPanel from './StreamPanel';
import './ifr.css';
import IFRPanelV2 from './IFRPanelV2';
import IFRPanelV3 from './IFRPanelV3';
const IFR = () => {
    const [touchStart, setTouchStart] = React.useState();
    const [touchEnd, setTouchEnd] = React.useState();
    const [visible, setVisible] = React.useState(1);
    const [atLeft, setAtLeft] = React.useState();
    const [atRight, setAtRight] = React.useState();
    const [ifrVersion, setIfrVersion] = React.useState('V3');
    const ifrRef = React.useRef(null);
    const streamRef = React.useRef(null);
    const handleStart = React.useCallback((e) => {
        let gridRef = undefined;
        switch (visible) {
            case 0:
                gridRef = ifrRef.current;
                break;
            case 1:
                gridRef = streamRef.current;
                break;
            default:
        }
        if (gridRef !== undefined && gridRef !== null) {
            setAtLeft(false);
            setAtRight(false);
            if (gridRef.scrollLeft === 0)
                setAtLeft(true);
            if (gridRef.scrollLeft > (gridRef.scrollWidth - gridRef.offsetWidth - 50))
                setAtRight(true);
        }
        setTouchEnd(undefined); // otherwise the swipe is fired even with usual touch events
        setTouchStart({ x: e.targetTouches[0].clientX, y: e.targetTouches[0].clientY });
    }, [visible]);
    const handleEnd = React.useCallback(() => {
        if (touchStart === undefined || touchEnd === undefined)
            return;
        const distanceX = touchStart.x - touchEnd.x;
        const isLeftSwipe = distanceX > 200;
        const isRightSwipe = distanceX < -200;
        if (isLeftSwipe && visible === 1 && atRight) {
            setVisible(visible + 1);
        }
        else if (isRightSwipe && visible === 2 && atLeft) {
            setVisible(visible - 1);
        }
    }, [atLeft, atRight, touchEnd, touchStart, visible]);
    const handleCancel = React.useCallback(() => {
        //    e.preventDefault();
    }, []);
    const handleMove = React.useCallback((e) => {
        setTouchEnd({ x: e.targetTouches[0].clientX, y: e.targetTouches[0].clientY });
    }, []);
    const onChangeIfrVersion = React.useCallback(() => setIfrVersion((current) => {
        console.log("Current: %o", current);
        return current === 'V2' ? 'V3' : 'V2';
    }), []);
    return (React.createElement(Card, { className: "co-card-main", style: { display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly' }, onTouchCancel: handleCancel, onTouchEnd: handleEnd, onTouchStart: handleStart, onTouchMove: handleMove },
        React.createElement("div", { className: 'co-ifr-panel', style: { display: 'flex', flexDirection: 'column', height: '100%' } },
            React.createElement(Switch, { label: ifrVersion === 'V3' ? 'Extended' : 'Basic', name: "switch", onChange: onChangeIfrVersion, status: ifrVersion === 'V3' ? SelectionStatus.SWITCHED : SelectionStatus.UNSWITCHED, value: ifrVersion === 'V3' ? 'true' : 'false' }),
            ifrVersion === 'V2' ?
                React.createElement(IFRPanelV2, { className: "co-ifr-panel", isVisible: visible === 1, ref: ifrRef })
                :
                    React.createElement(IFRPanelV3, { className: "co-ifr-panel", isVisible: visible === 1, ref: ifrRef })),
        React.createElement(StreamPanel, { className: "co-ifr-panel", isVisible: visible === 2, ref: streamRef })));
};
export default IFR;
